import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.search');
import { OnInit, OnDestroy, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-search',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.search/view.scss */
:host {
  display: block;
  height: 100%;
}

.keyword-expansion-wave-text {
  display: inline-flex;
  align-items: baseline;
  white-space: nowrap;
}

.keyword-expansion-wave-char {
  display: inline-block;
  animation: keyword-expansion-char-wave 1.15s ease-in-out infinite;
}

.keyword-expansion-wave-space {
  width: 0.35em;
}

.facet-loading-wave {
  display: inline-block;
  color: transparent;
  background: linear-gradient(90deg, #4A6FD8 0%, #8EA3F3 35%, #2C4A99 70%, #4A6FD8 100%);
  background-size: 220% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  animation: facet-text-wave 1.45s ease-in-out infinite;
}

.facet-skeleton-shimmer {
  position: relative;
  overflow: hidden;
  background: #f3f4f6;
}

.facet-skeleton-shimmer::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.85), transparent);
  animation: facet-skeleton-wave 1.35s ease-in-out infinite;
}

.expanded-keyword-list-collapsed {
  max-height: 1.625rem;
  overflow: hidden;
}

@keyframes facet-text-wave {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes keyword-expansion-char-wave {
  0%, 60%, 100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-0.28em);
  }
}
@keyframes facet-skeleton-wave {
  100% {
    transform: translateX(100%);
  }
}
@media (prefers-reduced-motion: reduce) {
  .keyword-expansion-wave-char {
    animation: none;
  }
}`],
})
export class PageSearchComponent implements OnInit, OnDestroy {
    private static SEARCH_STATE_KEY = 'korenet_search_state_v3_collapsed_facets';
    private static LEGACY_SEARCH_STATE_KEYS = [
        'korenet_search_state',
        'korenet_search_state_v2_full_facets'
    ];
    private static AGENT_SUMMARY_KEY = 'agent_recommendation_summary';
    private static AGENT_RESEARCHERS_KEY = 'agent_recommended_researchers';
    private static AGENT_QUERY_KEY = 'agent_recommendation_query';
    private static AGENT_RESULT_META_KEY = 'agent_recommendation_result_meta';

    public searchTab: string = 'researcher';
    public searchTabDropdownOpen: boolean = false;
    public searchText: string = '';
    public fuzzySearch: boolean = false;
    public page: number = 1;
    public dump: number = 10;
    public total: number = 0;
    public rows: any[] = [];
    public loading: boolean = false;
    public lastPage: number = 1;

    public sort: string = 'total';
    public order: string = 'DESC';
    public isLoggedIn: boolean = false;
    public bookmarks: any = {};
    public sortOptions: any[] = [
        { value: 'match', label: '매칭성과순' },
        { value: 'total', label: '총 성과물순' },
        { value: 'paper', label: '논문순' },
        { value: 'patent', label: '특허순' },
        { value: 'report', label: '보고서순' }
    ];
    public searchTabOptions: any[] = [
        { value: 'researcher', label: '연구자' },
        { value: 'keyword', label: '키워드' }
    ];
    private readonly keywordSortValues: string[] = ['match', 'paper', 'report', 'patent'];

    public popoverCardId: string = '';
    public showFilters: boolean = false;
    public showEmptyGuide: boolean = true;

    // 에이전트 추천 결과 모드
    public agentMode: boolean = false;
    public agentSummary: string = '';
    public agentResultId: string = '';

    // 패싯 네비게이터
    public facets: any = { orgs: [], keywords: [] };
    public selectedOrgs: string[] = [];
    public selectedKeywords: string[] = [];
    public expandedKeywords: string[] = [];
    public showAllExpandedKeywords: boolean = false;
    public keywordExpansionActive: boolean = false;
    public keywordExpansionSlow: boolean = false;
    public keywordExpansionElapsedSeconds: number = 0;
    public keywordExpansionModelError: string = '';
    public facetLoading: boolean = false;
    public facetSkeletonVisible: boolean = false;
    public facetSkeletonChips: number[] = [1, 2, 3, 4, 5, 6, 7, 8];
    public showFacetPanel: boolean = false;
    public openFacetCategory: string = '';
    public showAllOrgs: boolean = false;
    public keywordsLimit: number = 30;

    private agentResultHandler: any = null;
    private facetRequestSeq: number = 0;
    private keywordSearchRequestSeq: number = 0;
    private keywordResultCacheToken: string = '';
    private keywordExpansionTimer: any = null;
    private keywordExpansionStartedAt: number = 0;
    private keywordExpansionPromptDismissed: boolean = false;
    private facetSkeletonTimer: any = null;
    private readonly facetSkeletonDelayMs: number = 300;
    private readonly minExpandedKeywordCount: number = 8;
    private readonly expandedKeywordCollapsedPreviewCount: number = 10;
    private readonly domainExpandedKeywordMap: { [key: string]: string[] } = {
        rna: [
            'RNA', '리보핵산', 'Ribonucleic Acid', 'RNA splicing', 'RNA 스플라이싱', 'mRNA',
            'messenger RNA', '전령 RNA', 'microRNA', 'miRNA', '마이크로RNA', 'siRNA',
            'small interfering RNA', 'RNA interference', 'RNA 간섭', 'lncRNA',
            'long non-coding RNA', 'noncoding RNA', '비암호화 RNA', 'RNA sequencing',
            'RNA-seq', 'RNA 염기서열분석', 'RNA virus', 'RNA 바이러스'
        ]
    };
    private keywordExpansionModelNotice: string = 'AI 키워드 확장을 완료하지 못했습니다. 일반 키워드 검색으로 다시 시도해 주세요.';

    constructor(@Inject( Service) public service: Service) { }

    private ensureKeywordResultCacheToken(): string {
        if (!this.keywordResultCacheToken) {
            this.keywordResultCacheToken = [
                Date.now().toString(36),
                Math.random().toString(36).slice(2, 10)
            ].join('-');
        }
        return this.keywordResultCacheToken;
    }

    private normalizeSearchTab(tab: string | null): string {
        return tab === 'keyword' ? 'keyword' : 'researcher';
    }

    private getDefaultFuzzy(tab: string = this.searchTab): boolean {
        return this.normalizeSearchTab(tab) === 'keyword';
    }

    private normalizeFuzzy(tab: string = this.searchTab, fuzzy: boolean = this.fuzzySearch): boolean {
        return this.normalizeSearchTab(tab) === 'keyword' && fuzzy;
    }

    private enforceFuzzyForCurrentTab(): boolean {
        const normalized = this.normalizeFuzzy(this.searchTab, this.fuzzySearch);
        if (this.fuzzySearch !== normalized) {
            this.fuzzySearch = normalized;
        }
        return normalized;
    }

    private readFuzzyParam(params: URLSearchParams, tab: string = this.searchTab): boolean {
        const value = params.get('fuzzy');
        const requested = value === 'true'
            ? true
            : (value === 'false' ? false : this.getDefaultFuzzy(tab));
        return this.normalizeFuzzy(tab, requested);
    }

    private getDefaultSort(tab: string = this.searchTab): string {
        return tab === 'keyword' ? 'match' : 'total';
    }

    public get activeSortOptions(): any[] {
        return this.sortOptionsForTab(this.searchTab);
    }

    public get selectedSearchTabOption(): any {
        return this.searchTabOptions.find((option: any) => option.value === this.searchTab) || this.searchTabOptions[0];
    }

    private sortOptionsForTab(tab: string = this.searchTab): any[] {
        if (this.normalizeSearchTab(tab) === 'keyword') {
            return this.keywordSortValues
                .map((value: string) => this.sortOptions.find((option: any) => option.value === value))
                .filter((option: any) => option);
        }
        return this.sortOptions.filter((option: any) => option.value !== 'match');
    }

    private normalizeSort(sort: string | null, tab: string = this.searchTab): string {
        const defaultSort = this.getDefaultSort(tab);
        const value = String(sort || defaultSort);
        const options = this.sortOptionsForTab(tab);
        return options.some((option: any) => option.value === value) ? value : defaultSort;
    }

    private resetFacetState(clearSelections: boolean = true) {
        if (clearSelections) {
            this.selectedOrgs = [];
            this.selectedKeywords = [];
        }
        this.facets = { orgs: [], keywords: [] };
        this.expandedKeywords = [];
        this.showAllExpandedKeywords = false;
        this.showFilters = false;
        this.showAllOrgs = false;
        this.keywordsLimit = 30;
        this.showFacetPanel = false;
        this.openFacetCategory = '';
        this.facetRequestSeq++;
        this.stopFacetLoading();
    }

    private readSavedSearchState(): any {
        try {
            const raw = sessionStorage.getItem(Component.SEARCH_STATE_KEY);
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    }

    private clearSavedSearchState() {
        try {
            sessionStorage.removeItem(Component.SEARCH_STATE_KEY);
        } catch { }
    }

    private clearLegacySearchState() {
        try {
            Component.LEGACY_SEARCH_STATE_KEYS.forEach((key: string) => sessionStorage.removeItem(key));
        } catch { }
    }

    private hasSavedSearchResults(state: any): boolean {
        return Array.isArray(state?.rows) && (state.rows.length > 0 || Number(state?.total || 0) > 0);
    }

    private savedSearchMatchesUrl(state: any, params: URLSearchParams): boolean {
        if (!this.hasSavedSearchResults(state)) return false;

        const agentIds = params.get('agent_ids');
        const agentResultId = (params.get('result_id') || '').trim();
        if (agentIds || agentResultId) {
            if (agentResultId && state.agentResultId) {
                return state.agentMode === true && state.agentResultId === agentResultId;
            }
            return state.agentMode === true;
        }

        const query = params.get('q');
        if (!query) return true;

        const urlTab = this.normalizeSearchTab(params.get('tab'));
        const urlSort = this.normalizeSort(params.get('sort'), urlTab);
        const urlPage = parseInt(params.get('page') || '1');
        const urlFuzzy = this.readFuzzyParam(params, urlTab);
        const stateTab = this.normalizeSearchTab(state.searchTab || 'researcher');
        const stateSort = this.normalizeSort(state.sort || null, stateTab);
        if (stateTab === 'researcher' && state.fuzzySearch === true) {
            return false;
        }
        const stateFuzzy = this.normalizeFuzzy(
            stateTab,
            typeof state.fuzzySearch === 'boolean' ? state.fuzzySearch : this.getDefaultFuzzy(stateTab)
        );

        return String(state.searchText || '') === query
            && stateTab === urlTab
            && stateSort === urlSort
            && Number(state.page || 1) === urlPage
            && stateFuzzy === urlFuzzy;
    }

    private restoreSavedSearchState(state: any, restoreResults: boolean = false): boolean {
        if (!state) return false;

        this.searchText = state.searchText || '';
        this.searchTab = this.normalizeSearchTab(state.searchTab || 'researcher');
        this.sort = this.normalizeSort(state.sort || null, this.searchTab);
        this.order = state.order || 'DESC';
        this.page = Number(state.page || 1);
        this.dump = Number(state.dump || this.dump || 10);
        this.fuzzySearch = this.normalizeFuzzy(
            this.searchTab,
            typeof state.fuzzySearch === 'boolean' ? state.fuzzySearch : this.getDefaultFuzzy(this.searchTab)
        );
        this.selectedOrgs = this.toStringArray(state.selectedOrgs);
        this.selectedKeywords = this.toStringArray(state.selectedKeywords);
        this.expandedKeywords = this.toStringArray(state.expandedKeywords);
        this.showAllExpandedKeywords = state.showAllExpandedKeywords === true;
        this.keywordExpansionModelError = String(state.keywordExpansionModelError || '');
        this.agentMode = state.agentMode === true;
        this.agentSummary = String(state.agentSummary || '');
        this.agentResultId = String(state.agentResultId || '');
        this.showFilters = state.showFilters === true;
        this.showAllOrgs = state.showAllOrgs === true;
        this.keywordsLimit = Math.max(30, Number(state.keywordsLimit || 30));
        this.loading = false;
        this.stopFacetLoading();
        this.keywordExpansionActive = false;
        this.keywordExpansionSlow = false;
        this.keywordExpansionElapsedSeconds = 0;

        if (!restoreResults || !this.hasSavedSearchResults(state)) {
            return false;
        }

        this.rows = state.rows || [];
        this.total = Number(state.total || this.rows.length || 0);
        this.lastPage = Number(state.lastPage || Math.ceil(this.total / this.dump) || 1);
        this.facets = {
            orgs: Array.isArray(state.facets?.orgs) ? state.facets.orgs : [],
            keywords: Array.isArray(state.facets?.keywords) ? state.facets.keywords : []
        };
        this.facets = this.normalizeFacetPayload(this.facets);
        this.showEmptyGuide = this.rows.length === 0 && !this.searchText.trim() && !this.agentMode;
        return true;
    }

    private buildSearchStateSnapshot(): any {
        return {
            searchText: this.searchText,
            searchTab: this.searchTab,
            page: this.page,
            dump: this.dump,
            total: this.total,
            lastPage: this.lastPage,
            sort: this.sort,
            order: this.order,
            fuzzySearch: this.normalizeFuzzy(this.searchTab, this.fuzzySearch),
            selectedOrgs: [...this.selectedOrgs],
            selectedKeywords: [...this.selectedKeywords],
            expandedKeywords: [...this.expandedKeywords],
            showAllExpandedKeywords: this.showAllExpandedKeywords,
            keywordExpansionModelError: this.keywordExpansionModelError,
            agentMode: this.agentMode,
            agentSummary: this.agentSummary,
            agentResultId: this.agentResultId,
            showEmptyGuide: this.showEmptyGuide,
            showFilters: this.showFilters,
            showAllOrgs: this.showAllOrgs,
            keywordsLimit: this.keywordsLimit,
            rows: this.rows || [],
            facets: this.facets || { orgs: [], keywords: [] },
            savedAt: Date.now()
        };
    }

    private saveSearchStateSnapshot() {
        try {
            sessionStorage.setItem(Component.SEARCH_STATE_KEY, JSON.stringify(this.buildSearchStateSnapshot()));
        } catch { }
    }

    public async ngOnInit() {
        await this.service.init();
        this.clearLegacySearchState();
        const params = new URLSearchParams(location.search);
        this.searchText = params.get('q') || '';
        this.searchTab = this.normalizeSearchTab(params.get('tab'));
        this.sort = this.normalizeSort(params.get('sort'), this.searchTab);
        this.page = parseInt(params.get('page') || '1');
        this.fuzzySearch = this.readFuzzyParam(params, this.searchTab);

        // sessionStorage에서 검색 상태 복원 (뒤로가기 시)
        const saved = this.readSavedSearchState();
        const restoreCachedResults = this.savedSearchMatchesUrl(saved, params);
        if (saved && (restoreCachedResults || (!params.get('q') && !params.get('agent_ids')))) {
            this.restoreSavedSearchState(saved, restoreCachedResults);
            this.clearSavedSearchState();
        } else if (saved) {
            this.clearSavedSearchState();
        }

        // 에이전트 결과 ID로 직접 진입
        const agentIds = params.get('agent_ids');
        const agentResultId = (params.get('result_id') || '').trim();
        const storedAgentMeta = this.getStoredAgentResultMeta();
        const storedCandidateIds = Array.isArray(storedAgentMeta.candidate_ids)
            ? storedAgentMeta.candidate_ids.map((id: any) => String(id || '').trim()).filter((id: string) => id)
            : [];
        if (restoreCachedResults) {
            this.showEmptyGuide = this.rows.length === 0 && !this.searchText.trim() && !this.agentMode;
            await this.checkSession();
            const ids = this.rows.map((r: any) => r.researcher_id).filter((id: string) => id);
            await this.checkBookmarks(ids);
            if (!this.agentMode) {
                this.updateUrlParams();
            }
            await this.service.render();
            if (!this.agentMode && this.searchText.trim() && !this.hasFacetData) {
                if (this.searchTab === 'keyword') {
                    this.loadKeywordFacets();
                } else {
                    this.loadFacets();
                }
            }
        } else if (agentIds || agentResultId) {
            const ids = (agentIds || (
                agentResultId && storedAgentMeta.result_id === agentResultId
                    ? storedCandidateIds.join(',')
                    : ''
            ))
                .split(',')
                .map(id => id.trim())
                .filter(id => id);
            this.searchTab = 'researcher';
            this.fuzzySearch = false;
            this.showEmptyGuide = false;
            this.agentSummary = '';
            this.agentResultId = agentResultId || storedAgentMeta.result_id || '';
            await this.checkSession();
            if (ids.length > 0) {
                await this.loadByIds(ids);
            } else {
                this.rows = [];
                this.total = 0;
                this.lastPage = 1;
            }
            this.agentMode = true;
            await this.service.render();
        } else if (this.searchText.trim()) {
            this.showEmptyGuide = false;
            await this.checkSession();
            if (this.searchTab === 'keyword') {
                await this.loadByKeyword();
                this.loadKeywordFacets();
            } else {
                await this.load();
                this.loadFacets();
            }
            await this.service.render();
        } else {
            await this.checkSession();
            await this.service.render();
        }

        // 챗봇에서 에이전트 결과를 받기 위한 이벤트 리스너
        this.agentResultHandler = async (e: any) => {
            const ids = e.detail?.ids || [];
            if (ids.length > 0) {
                this.searchTab = 'researcher';
                this.fuzzySearch = false;
                this.agentMode = true;
                this.agentResultId = String(e.detail?.result_id || this.getStoredAgentResultMeta().result_id || '');
                this.showEmptyGuide = false;
                this.agentSummary = '';
                await this.loadByIds(ids);
                await this.service.render();
            }
        };
        window.addEventListener('chatbot-agent-results', this.agentResultHandler);
    }

    ngOnDestroy() {
        if (this.agentResultHandler) {
            window.removeEventListener('chatbot-agent-results', this.agentResultHandler);
            this.agentResultHandler = null;
        }
        this.clearKeywordExpansionStatus();
        this.clearFacetSkeletonTimer();
    }

    private getStoredAgentSummary(): string {
        try {
            return sessionStorage.getItem(Component.AGENT_SUMMARY_KEY) || '';
        } catch {
            return '';
        }
    }

    private getStoredAgentResearchers(): any[] {
        try {
            const raw = sessionStorage.getItem(Component.AGENT_RESEARCHERS_KEY) || '[]';
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    }

    private getStoredAgentResultMeta(): any {
        try {
            const raw = sessionStorage.getItem(Component.AGENT_RESULT_META_KEY) || '';
            if (!raw) return {};
            const parsed = JSON.parse(raw);
            return parsed && typeof parsed === 'object' ? parsed : {};
        } catch {
            return {};
        }
    }

    private filterStoredRowsToCurrentResults(storedRows: any[] = []): any[] {
        const visibleIds = new Set(
            (this.rows || [])
                .map((row: any) => row.researcher_id || row.id || '')
                .filter((id: string) => id)
        );
        if (!visibleIds.size) return [];
        return (storedRows || []).filter((row: any) => {
            const key = row.researcher_id || row.id || '';
            return key && visibleIds.has(key);
        });
    }

    private clearStoredAgentContext() {
        try {
            sessionStorage.removeItem(Component.AGENT_SUMMARY_KEY);
            sessionStorage.removeItem(Component.AGENT_RESEARCHERS_KEY);
            sessionStorage.removeItem(Component.AGENT_QUERY_KEY);
            sessionStorage.removeItem(Component.AGENT_RESULT_META_KEY);
        } catch { }
    }

    private getStoredAgentQuery(): string {
        try {
            return sessionStorage.getItem(Component.AGENT_QUERY_KEY) || '';
        } catch {
            return '';
        }
    }

    private looksLikeRawStructuredText(text: string): boolean {
        const value = String(text || '').trim();
        if (!value) return false;
        if (value.startsWith('[') || value.startsWith('{')) return true;
        return value.includes('"researcher_id"') || value.includes('"matched_keywords"') || value.includes('"keyword_match_count"');
    }

    private async refreshAgentSummary() {
        if (!this.agentMode || !this.rows.length) {
            return;
        }

        const storedRows = this.getStoredAgentResearchers();
        const visibleStoredRows = this.filterStoredRowsToCurrentResults(storedRows);
        const query = this.getStoredAgentQuery() || this.searchText || '';
        const targetRows = (visibleStoredRows.length > 0 ? visibleStoredRows : this.rows).slice(0, 10);

        try {
            const { code, data } = await wiz.call('generate_agent_summary', {
                message: query,
                researchers: JSON.stringify(targetRows),
            });
            if (code === 200) {
                const summary = String(data?.summary || '').trim();
                if (summary && !this.looksLikeRawStructuredText(summary)) {
                    this.agentSummary = summary;
                    try {
                        sessionStorage.setItem(Component.AGENT_SUMMARY_KEY, summary);
                    } catch { }
                    return;
                }
            }
        } catch { }

        const fallback = this.buildFallbackAgentSummary(targetRows);
        if (fallback) {
            this.agentSummary = fallback;
        }
    }

    private normalizeKeywordList(value: any): string[] {
        if (Array.isArray(value)) {
            return value.map((item: any) => String(item || '').trim()).filter((item: string) => item);
        }
        if (typeof value === 'string') {
            return value
                .split(/[;,|]/)
                .map((item: string) => item.trim())
                .filter((item: string) => item);
        }
        return [];
    }

    private toStringArray(value: any): string[] {
        return this.normalizeKeywordList(value);
    }

    private ensureFacetSelections() {
        if (!Array.isArray(this.selectedOrgs)) {
            this.selectedOrgs = this.toStringArray(this.selectedOrgs);
        }
        if (!Array.isArray(this.selectedKeywords)) {
            this.selectedKeywords = this.toStringArray(this.selectedKeywords);
        }
    }

    private normalizeKeywordTerm(value: any): string {
        return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
    }

    private uniqueKeywords(keywords: string[]): string[] {
        const seen = new Set<string>();
        return keywords
            .map((keyword: string) => String(keyword || '').trim())
            .filter((keyword: string) => {
                const key = this.normalizeKeywordTerm(keyword);
                if (!key || seen.has(key)) return false;
                seen.add(key);
                return true;
            });
    }

    private hasHangul(value: string): boolean {
        return /[가-힣]/.test(String(value || ''));
    }

    private genericMinimumKeywordTerms(keyword: string): string[] {
        const base = String(keyword || '').trim();
        if (!base) return [];
        const suffixes = this.hasHangul(base)
            ? ['연구', '기술', '분석', '모델', '시스템', '응용', '방법', '평가']
            : ['research', 'technology', 'analysis', 'model', 'system', 'application', 'method', 'evaluation'];
        return [base, ...suffixes.map((suffix: string) => `${base} ${suffix}`)];
    }

    private supplementExpandedKeywords(keywords: any, keyword: string = this.searchText): string[] {
        const base = String(keyword || '').trim();
        const baseKey = this.normalizeKeywordTerm(base);
        const domainKeywords = this.domainExpandedKeywordMap[baseKey] || [];
        let terms = this.uniqueKeywords([base, ...this.normalizeKeywordList(keywords), ...domainKeywords]);
        if (terms.length >= this.minExpandedKeywordCount || !base) return terms;
        terms = this.uniqueKeywords([...terms, ...this.genericMinimumKeywordTerms(base)]);
        return terms;
    }

    private mergeFacetList(apiItems: any[], rowItems: any[]): any[] {
        const merged = new Map<string, any>();

        (apiItems || []).forEach((item: any) => {
            const name = String(item?.name || '').trim();
            const key = this.normalizeKeywordTerm(name);
            if (!key) return;
            merged.set(key, { name, count: Number(item?.count || 0) || 0 });
        });

        (rowItems || []).forEach((item: any) => {
            const name = String(item?.name || '').trim();
            const key = this.normalizeKeywordTerm(name);
            if (!key) return;
            const count = Number(item?.count || 0) || 0;
            const current = merged.get(key);
            if (current) {
                current.count = Math.max(current.count, count);
            } else {
                merged.set(key, { name, count });
            }
        });

        return Array.from(merged.values())
            .sort((a: any, b: any) => b.count - a.count || a.name.localeCompare(b.name));
    }

    private normalizeFacetPayload(apiFacets: any): any {
        return {
            orgs: this.mergeFacetList(apiFacets?.orgs || [], []),
            keywords: this.mergeFacetList(apiFacets?.keywords || [], [])
        };
    }

    private canReuseExpandedKeywords(): boolean {
        const currentTerm = this.normalizeKeywordTerm(this.searchText);
        return !!currentTerm && this.expandedKeywords.some(
            (keyword: string) => this.normalizeKeywordTerm(keyword) === currentTerm
        ) && this.hasUsefulExpandedKeywords(this.expandedKeywords, currentTerm);
    }

    private hasUsefulExpandedKeywords(keywords: string[], baseTerm: string = this.normalizeKeywordTerm(this.searchText)): boolean {
        if (!baseTerm) return false;
        return this.uniqueKeywords(keywords || []).some(
            (keyword: string) => this.normalizeKeywordTerm(keyword) !== baseTerm
        );
    }

    private clearKeywordExpansionStatus() {
        if (this.keywordExpansionTimer) {
            clearInterval(this.keywordExpansionTimer);
            this.keywordExpansionTimer = null;
        }
        this.keywordExpansionStartedAt = 0;
        this.keywordExpansionElapsedSeconds = 0;
        this.keywordExpansionActive = false;
        this.keywordExpansionSlow = false;
        this.keywordExpansionPromptDismissed = false;
    }

    private clearKeywordExpansionModelError() {
        this.keywordExpansionModelError = '';
    }

    private clearFacetSkeletonTimer() {
        if (this.facetSkeletonTimer) {
            clearTimeout(this.facetSkeletonTimer);
            this.facetSkeletonTimer = null;
        }
    }

    private startFacetLoading() {
        this.clearFacetSkeletonTimer();
        this.facetLoading = true;
        this.facetSkeletonVisible = this.showFilters;
        this.facetSkeletonTimer = setTimeout(async () => {
            this.facetSkeletonTimer = null;
            if (!this.facetLoading || this.facetSkeletonVisible) return;
            this.facetSkeletonVisible = true;
            await this.service.render();
        }, this.facetSkeletonDelayMs);
    }

    private stopFacetLoading() {
        this.facetLoading = false;
        this.facetSkeletonVisible = false;
        this.clearFacetSkeletonTimer();
    }

    private isModelProblemMessage(message: any): boolean {
        const text = String(message || '').toLowerCase();
        if (!text) return false;
        return [
            'model',
            'llm',
            'ollama',
            'api/chat',
            'not found',
            'notfound',
            'timeout',
            'timed out',
            'connection',
            'refused',
            'unavailable',
            'empty keyword response',
            '모델'
        ].some((marker: string) => text.includes(marker));
    }

    private keywordExpansionErrorFromResponse(data: any): string {
        const message = String(data?.keyword_expansion_error || data?.model_error_message || '').trim();
        if (message) return message;
        if (data?.model_error === true) return this.keywordExpansionModelNotice;
        return '';
    }

    private startKeywordExpansionStatus() {
        this.clearKeywordExpansionStatus();
        this.keywordExpansionActive = true;
        this.keywordExpansionStartedAt = Date.now();
        this.keywordExpansionTimer = setInterval(async () => {
            if (!this.keywordExpansionActive) return;
            this.keywordExpansionElapsedSeconds = Math.floor((Date.now() - this.keywordExpansionStartedAt) / 1000);
            if (this.keywordExpansionElapsedSeconds >= 30 && !this.keywordExpansionPromptDismissed) {
                this.keywordExpansionSlow = true;
            }
            await this.service.render();
        }, 1000);
    }

    public async continueKeywordExpansionWait() {
        this.keywordExpansionPromptDismissed = true;
        this.keywordExpansionSlow = false;
        await this.service.render();
    }

    public async useExactKeywordSearch() {
        if (!this.searchText.trim()) return;
        const requestSeq = ++this.keywordSearchRequestSeq;
        this.clearKeywordExpansionStatus();
        this.clearKeywordExpansionModelError();
        this.fuzzySearch = false;
        this.expandedKeywords = [];
        this.showAllExpandedKeywords = false;
        this.page = 1;
        await this.service.render();
        await this.loadByKeyword(1, { requestSeq, forceExact: true });
        this.loadKeywordFacets();
    }

    private getRawMatchedKeywords(row: any): string[] {
        return this.normalizeKeywordList(row?.matched_keywords);
    }

    private getPrimaryMatchedKeywords(row: any): string[] {
        return this.normalizeKeywordList(row?.primary_matched_keywords);
    }

    private getKeywordFocusTerms(row: any): string[] {
        const keywords: string[] = [];
        const searchKeyword = row?._rendered_search_keyword || this.searchText.trim();

        if (this.searchTab === 'keyword') {
            keywords.push(...this.getPrimaryMatchedKeywords(row));
            if (searchKeyword) keywords.push(searchKeyword);
            keywords.push(...this.selectedKeywords);
            return this.uniqueKeywords(keywords).slice(0, 20);
        }

        keywords.push(...this.getRawMatchedKeywords(row));
        keywords.push(...this.selectedKeywords);
        if (searchKeyword) {
            keywords.push(searchKeyword);
        }
        return this.uniqueKeywords(keywords).slice(0, 20);
    }

    private getKeywordFocusMatch(tag: string, row: any): any {
        const tagKey = this.normalizeKeywordTerm(tag);
        const fallback = { priority: 3, index: 999999 };
        if (!tagKey) return fallback;

        const focusTerms = this.getKeywordFocusTerms(row);
        if (focusTerms.length === 0) return fallback;

        for (let i = 0; i < focusTerms.length; i++) {
            if (tagKey === this.normalizeKeywordTerm(focusTerms[i])) {
                return { priority: 0, index: i };
            }
        }
        for (let i = 0; i < focusTerms.length; i++) {
            const keywordKey = this.normalizeKeywordTerm(focusTerms[i]);
            if (keywordKey && tagKey.includes(keywordKey)) {
                return { priority: 1, index: i };
            }
        }
        for (let i = 0; i < focusTerms.length; i++) {
            const keywordKey = this.normalizeKeywordTerm(focusTerms[i]);
            if (tagKey.length >= 2 && keywordKey.includes(tagKey)) {
                return { priority: 2, index: i };
            }
        }
        return fallback;
    }

    private getDetailMatchedKeywordTags(row: any): string[] {
        const tags = this._getAllTags(row);
        if (tags.length === 0) return [];

        return tags
            .map((tag: string, index: number) => ({
                tag,
                index,
                match: this.getKeywordFocusMatch(tag, row)
            }))
            .filter((item: any) => item.match.priority < 3)
            .sort((a: any, b: any) => {
                if (a.match.priority !== b.match.priority) return a.match.priority - b.match.priority;
                if (a.match.index !== b.match.index) return a.match.index - b.match.index;
                return a.index - b.index;
            })
            .map((item: any) => item.tag);
    }

    private getKeywordSearchMatchedKeywords(row: any, detailKeywords: string[] = this.getDetailMatchedKeywordTags(row)): string[] {
        const rawKeywords = this.getRawMatchedKeywords(row);
        if (rawKeywords.length > 0) return rawKeywords;
        if (detailKeywords.length > 0) return this.uniqueKeywords(detailKeywords);
        return this.getPrimaryMatchedKeywords(row);
    }

    private freezeRenderedMatchedKeywords(rows: any[], searchKeyword: string = this.searchText.trim()) {
        (rows || []).forEach((row: any) => {
            if (!row) return;
            row._rendered_search_keyword = String(searchKeyword || '').trim();
            const detailKeywords = this.getDetailMatchedKeywordTags(row);
            if (this.searchTab === 'keyword') {
                row._rendered_matched_keywords = this.getKeywordSearchMatchedKeywords(row, detailKeywords);
                return;
            }
            row._rendered_matched_keywords = detailKeywords.length > 0
                ? this.uniqueKeywords(detailKeywords).slice(0, 20)
                : this.getRawMatchedKeywords(row).slice(0, 20);
        });
    }

    public getMatchedKeywords(row: any): string[] {
        if (Array.isArray(row?._rendered_matched_keywords)) {
            return row._rendered_matched_keywords;
        }
        const detailKeywords = this.getDetailMatchedKeywordTags(row);
        if (this.searchTab === 'keyword') return this.getKeywordSearchMatchedKeywords(row, detailKeywords);
        if (detailKeywords.length > 0) return this.uniqueKeywords(detailKeywords).slice(0, 20);
        return this.getRawMatchedKeywords(row).slice(0, 20);
    }

    public getVisibleMatchedKeywords(row: any): string[] {
        const keywords = this.getMatchedKeywords(row);
        if (this.searchTab === 'keyword') return keywords;
        return keywords.slice(0, 5);
    }

    public getExtraMatchedKeywordCount(row: any): number {
        if (this.searchTab === 'keyword') return 0;
        return Math.max(0, this.getMatchedKeywords(row).length - 5);
    }

    private getResearcherDetailKeywords(row: any): string[] {
        const keywords: string[] = [];
        const searchKeyword = row?._rendered_search_keyword || this.searchText.trim();

        if (this.searchTab === 'keyword') {
            keywords.push(...this.getPrimaryMatchedKeywords(row));
            if (searchKeyword) keywords.push(searchKeyword);
            keywords.push(...this.selectedKeywords);
            return this.uniqueKeywords(keywords).slice(0, 20);
        }

        const matchedKeywords = this.getMatchedKeywords(row);
        if (matchedKeywords.length === 0 && searchKeyword) {
            keywords.push(searchKeyword);
        }
        keywords.push(...matchedKeywords);
        keywords.push(...this.selectedKeywords);

        return this.uniqueKeywords(keywords).slice(0, 20);
    }

    private buildResearcherDetailUrl(id: string, row: any): string {
        const keywords = this.getResearcherDetailKeywords(row);
        if (keywords.length === 0) return `/researcher/${id}`;

        const params = new URLSearchParams();
        params.set('keywords', keywords.join('|'));
        return `/researcher/${id}?${params.toString()}`;
    }

    public getMatchedKeywordCount(row: any): number {
        const displayCount = this.getMatchedKeywords(row).length;
        if (displayCount > 0) return displayCount;
        if (this.searchTab === 'keyword' && this.hasPrimaryKeywordMetrics(row)) {
            return this.toCount(row?.primary_keyword_match_count);
        }
        return this.toCount(row?.keyword_match_count);
    }

    private toCount(value: any): number {
        const count = Number(value || 0);
        return Number.isFinite(count) ? count : 0;
    }

    private hasPrimaryKeywordMetrics(row: any): boolean {
        if (!row) return false;
        return this.toCount(row?.primary_keyword_pub_count) > 0
            || this.toCount(row?.primary_keyword_paper_count) > 0
            || this.toCount(row?.primary_keyword_patent_count) > 0
            || this.toCount(row?.primary_keyword_report_count) > 0;
    }

    public getKeywordPublicationCount(row: any): number {
        if (this.searchTab === 'keyword' && this.hasPrimaryKeywordMetrics(row)) {
            const primaryCount = this.toCount(row?.primary_keyword_pub_count);
            if (primaryCount > 0) return primaryCount;
            return this.toCount(row?.primary_keyword_paper_count)
                + this.toCount(row?.primary_keyword_patent_count)
                + this.toCount(row?.primary_keyword_report_count);
        }
        const explicitCount = this.toCount(row?.keyword_pub_count);
        if (explicitCount > 0) return explicitCount;
        return this.getKeywordPaperCount(row) + this.getKeywordPatentCount(row) + this.getKeywordReportCount(row);
    }

    public getKeywordPaperCount(row: any): number {
        if (this.searchTab === 'keyword' && this.hasPrimaryKeywordMetrics(row)) {
            return this.toCount(row?.primary_keyword_paper_count);
        }
        return this.toCount(row?.keyword_paper_count);
    }

    public getKeywordPatentCount(row: any): number {
        if (this.searchTab === 'keyword' && this.hasPrimaryKeywordMetrics(row)) {
            return this.toCount(row?.primary_keyword_patent_count);
        }
        return this.toCount(row?.keyword_patent_count);
    }

    public getKeywordReportCount(row: any): number {
        if (this.searchTab === 'keyword' && this.hasPrimaryKeywordMetrics(row)) {
            return this.toCount(row?.primary_keyword_report_count);
        }
        return this.toCount(row?.keyword_report_count);
    }

    public getRecommendationReason(row: any): string {
        if (!row) return '';

        const reasons: string[] = [];
        const primaryMetricMode = this.searchTab === 'keyword' && this.hasPrimaryKeywordMetrics(row);
        const directMatchedKeywords = this.getPrimaryMatchedKeywords(row);
        const matchedKeywords = (
            primaryMetricMode
                ? directMatchedKeywords
                : this.normalizeKeywordList(row.matched_keywords)
        ).slice(0, 3);
        const sharedKeywords = this.normalizeKeywordList(row.shared_keywords).slice(0, 3);
        const keywordPreview = this.normalizeKeywordList(row.keyword_kor || row.keyword).slice(0, 3);

        const keywordPubCount = primaryMetricMode
            ? Number(row.primary_keyword_pub_count || 0)
            : Number(row.keyword_pub_count || 0);
        const keywordMatchCount = primaryMetricMode
            ? Number(row.primary_keyword_match_count || matchedKeywords.length || 0)
            : Number(row.keyword_match_count || matchedKeywords.length || 0);
        const paperCount = Number(row.paper_cnt || 0);
        const reportCount = Number(row.report_cnt || 0);
        const patentCount = Number(row.patent_cnt || 0);
        const coauthorPaperCount = Number(row.coauthor_paper_count || 0);
        const similarityScore = Number(row.similarity_score || 0);

        if (matchedKeywords.length > 0) {
            const keywordText = matchedKeywords.join(', ');
            if (keywordPubCount > 0) {
                reasons.push(`${keywordText} 관련 성과가 ${keywordPubCount}건 확인돼 질문 키워드와 직접 연결됩니다.`);
            } else {
                reasons.push(`${keywordText} 등 ${keywordMatchCount}개 핵심 키워드가 질문 주제와 맞닿아 있습니다.`);
            }
        } else if (sharedKeywords.length > 0) {
            const sharedText = sharedKeywords.join(', ');
            if (coauthorPaperCount > 0) {
                reasons.push(`${sharedText} 주제가 겹치고 공동 연구 ${coauthorPaperCount}건이 있어 연관성이 높습니다.`);
            } else {
                const scoreText = similarityScore > 0 ? similarityScore.toFixed(2).replace(/\.00$/, '') : '상당';
                reasons.push(`${sharedText} 주제가 겹치며 유사도 ${scoreText} 수준의 가까운 연구 흐름을 보입니다.`);
            }
        }

        if (paperCount > 0) {
            reasons.push(`관련 분야 논문 ${paperCount}편을 보유해 후속 검토 가치가 높습니다.`);
        } else if (reportCount > 0 || patentCount > 0) {
            const outputs = [];
            if (reportCount > 0) outputs.push(`보고서 ${reportCount}건`);
            if (patentCount > 0) outputs.push(`특허 ${patentCount}건`);
            reasons.push(`${outputs.join(', ')}을 보유한 실무형 연구 이력이 확인됩니다.`);
        } else if (keywordPreview.length > 0) {
            reasons.push(`${keywordPreview.join(', ')} 중심으로 연구를 이어 온 전문가입니다.`);
        }

        return reasons.slice(0, 2).join(' ');
    }

    private buildFallbackAgentSummary(rows: any[]): string {
        const sourceRows = rows || [];
        if (sourceRows.length === 0) return '';

        const keywordCounts = new Map<string, number>();
        let hasDirectMatch = false;
        let hasSimilarity = false;
        let hasNetwork = false;

        for (const row of sourceRows) {
            const matchedKeywords = this.normalizeKeywordList(row?.matched_keywords);
            const sharedKeywords = this.normalizeKeywordList(row?.shared_keywords);
            const previewKeywords = this.normalizeKeywordList(row?.keyword || row?.keyword_kor).slice(0, 2);
            const uniqueKeywords = new Set<string>([...matchedKeywords, ...sharedKeywords, ...previewKeywords]);

            if (matchedKeywords.length > 0 || Number(row?.keyword_pub_count || 0) > 0) {
                hasDirectMatch = true;
            }
            if (sharedKeywords.length > 0 || Number(row?.similarity_score || 0) > 0) {
                hasSimilarity = true;
            }
            if (Number(row?.coauthor_paper_count || 0) > 0) {
                hasNetwork = true;
            }

            uniqueKeywords.forEach((keyword: string) => {
                const normalized = String(keyword || '').trim();
                if (!normalized) return;
                keywordCounts.set(normalized, (keywordCounts.get(normalized) || 0) + 1);
            });
        }

        const topKeywords = Array.from(keywordCounts.entries())
            .sort((left, right) => {
                if (right[1] !== left[1]) return right[1] - left[1];
                return left[0].localeCompare(right[0], 'ko');
            })
            .slice(0, 3)
            .map(([keyword]) => keyword);

        const overview = topKeywords.length > 0
            ? `추천된 연구자들은 ${topKeywords.join(', ')}을 중심으로 질문 주제와 맞닿은 연구 경험을 보여 함께 추천되었습니다.`
            : '추천된 연구자들은 질문 주제와 맞닿은 연구 경험과 전문성을 공통으로 보여 함께 추천되었습니다.';

        const evidence = hasDirectMatch && (hasSimilarity || hasNetwork)
            ? '직접적인 주제 적합성에 더해 유사한 연구 흐름과 협업 맥락도 함께 확인돼, 한 방향이 아니라 여러 근거에서 검토 가치가 높은 후보들입니다.'
            : hasDirectMatch
                ? '관련 성과와 연구 키워드에서 공통성이 확인돼 우선 검토할 후보군으로 정리했습니다.'
                : hasSimilarity || hasNetwork
                    ? '세부 주제의 연결성과 연구 흐름의 유사성이 확인돼 함께 검토할 가치가 있는 후보들입니다.'
                    : '질문과 연결되는 연구 배경과 전문 주제가 겹쳐 종합 추천 대상으로 정리했습니다.';

        return `${overview} ${evidence}`.trim();
    }

    public getAgentSummaryText(): string {
        if (!this.agentMode) return '';

        if (this.agentSummary && !this.looksLikeRawStructuredText(this.agentSummary)) {
            return this.agentSummary;
        }

        const storedRows = this.getStoredAgentResearchers();
        const visibleStoredRows = this.filterStoredRowsToCurrentResults(storedRows);
        return this.buildFallbackAgentSummary(visibleStoredRows.length > 0 ? visibleStoredRows : this.rows);
    }

    private scoreComponentMeta(): any[] {
        return [
            { key: 'paper', weightKey: 'paper_count_weight', label: '논문 수' },
            { key: 'report', weightKey: 'report_count_weight', label: '보고서 수' },
            { key: 'recency', weightKey: 'recent_count_weight', label: '최근 3년' },
            { key: 'patent', weightKey: 'patent_count_weight', label: '특허 수' },
            { key: 'focus', weightKey: 'focus_score_weight', label: '집중도' },
            { key: 'publication', weightKey: 'publication_score_weight', label: '성과물 점수' },
            { key: 'journal_level', weightKey: 'journal_level_score_weight', label: '학술지 수준' },
        ];
    }

    private numberValue(value: any, fallback: number = 0): number {
        const number = Number(value);
        return Number.isFinite(number) ? number : fallback;
    }

    private getScoreBreakdown(row: any): any {
        return row?.score_breakdown || {};
    }

    private getScoreWeights(row: any): any {
        const breakdown = this.getScoreBreakdown(row);
        return breakdown.weights_applied || row?.weights_applied || {};
    }

    private getNormalizedComponents(row: any): any {
        const breakdown = this.getScoreBreakdown(row);
        return breakdown.normalized_score_components || row?.normalized_score_components || {};
    }

    public formatScore(value: any): string {
        const number = Number(value);
        if (!Number.isFinite(number)) return '0';
        if (Math.abs(number) >= 100) return number.toFixed(0);
        if (Math.abs(number) >= 10) return number.toFixed(2).replace(/\.?0+$/, '');
        return number.toFixed(4).replace(/\.?0+$/, '');
    }

    public hasScoreEvidence(row: any): boolean {
        if (!this.agentMode || !row) return false;
        const breakdown = this.getScoreBreakdown(row);
        const hasScore = row.score !== undefined && row.score !== null && Number(row.score) > 0;
        const hasWeighted = row.weighted_score !== undefined && row.weighted_score !== null && Number(row.weighted_score) > 0;
        const hasComponents = Object.keys(this.getNormalizedComponents(row)).length > 0
            || Object.keys(row.score_components || {}).length > 0
            || Object.keys(breakdown.score_components || {}).length > 0;
        return hasScore || hasWeighted || hasComponents;
    }

    public hasAgentEvidence(): boolean {
        return this.agentMode && (this.rows || []).some((row: any) => this.hasScoreEvidence(row));
    }

    public getAgentEvidenceRows(): any[] {
        return (this.rows || []).filter((row: any) => this.hasScoreEvidence(row)).slice(0, 5);
    }

    public getAppliedWeightChips(row: any = null): any[] {
        const target = row || this.getAgentEvidenceRows()[0];
        if (!target) return [];
        const weights = this.getScoreWeights(target);
        return this.scoreComponentMeta()
            .map((meta: any) => ({
                label: meta.label,
                value: this.numberValue(weights[meta.weightKey], NaN)
            }))
            .filter((item: any) => Number.isFinite(item.value))
            .map((item: any) => ({
                label: item.label,
                text: `${Math.round(item.value * 100)}%`
            }));
    }

    public getAgentMatchedKeywordPreview(): string[] {
        const seen = new Set<string>();
        const keywords: string[] = [];
        (this.rows || []).forEach((row: any) => {
            this.getMatchedKeywords(row).forEach((keyword: string) => {
                const key = this.normalizeKeywordTerm(keyword);
                if (!key || seen.has(key)) return;
                seen.add(key);
                keywords.push(keyword);
            });
        });
        return keywords.slice(0, 12);
    }

    public getScoreFormula(row: any): string {
        if (!this.hasScoreEvidence(row)) return '';
        const breakdown = this.getScoreBreakdown(row);
        const finalScore = this.numberValue(row?.score, this.numberValue(breakdown.score, 0));
        const weightedScore = this.numberValue(row?.weighted_score, this.numberValue(breakdown.weighted_score, 0));
        const keywordWeight = this.numberValue(row?.keyword_weight, this.numberValue(breakdown.keyword_weight, 1));
        const keywordPublicationScore = this.numberValue(
            row?.keyword_publication_score,
            this.numberValue(breakdown.keyword_publication_score, 0)
        );

        if (finalScore > 0 && weightedScore > 0) {
            return `최종점수 ${this.formatScore(finalScore)} = 사용자 가중점수 ${this.formatScore(weightedScore)} × 키워드 동시매칭 ${this.formatScore(keywordWeight)}`;
        }
        if (finalScore > 0 && keywordPublicationScore > 0) {
            return `최종점수 ${this.formatScore(finalScore)} = 키워드 성과점수 ${this.formatScore(keywordPublicationScore)} × 키워드 동시매칭 ${this.formatScore(keywordWeight)}`;
        }
        return '';
    }

    public getAgentSortBasisText(): string {
        if (!this.hasAgentEvidence()) {
            return '현재 목록은 AI 에이전트가 전달한 추천 순서를 유지합니다.';
        }
        return '정렬은 최종점수가 높은 순서를 기준으로 하며, 최종점수는 사용자 가중점수에 키워드 동시매칭 가중치를 곱해 계산합니다.';
    }

    public getScoreComponentRows(row: any): any[] {
        if (!this.hasScoreEvidence(row)) return [];
        const weights = this.getScoreWeights(row);
        const normalized = this.getNormalizedComponents(row);
        return this.scoreComponentMeta()
            .map((meta: any) => {
                const weight = this.numberValue(weights[meta.weightKey], NaN);
                const relative = this.numberValue(normalized[meta.key], 0);
                const contribution = Number.isFinite(weight) ? weight * relative : 0;
                return {
                    label: meta.label,
                    weight,
                    relative,
                    contribution,
                    weightText: Number.isFinite(weight) ? `${Math.round(weight * 100)}%` : '-',
                    relativeText: this.formatScore(relative),
                    contributionText: this.formatScore(contribution),
                };
            })
            .filter((item: any) => Number.isFinite(item.weight) || item.relative > 0 || item.contribution > 0);
    }

    public getScoreEvidenceText(row: any): string {
        const keywords = this.getMatchedKeywords(row).slice(0, 5);
        const keywordText = keywords.length > 0 ? `매칭 키워드 ${keywords.join(', ')}` : '';
        const formula = this.getScoreFormula(row);
        return [formula, keywordText].filter((part: string) => part).join(' · ');
    }

    private mergeAgentRows(rows: any[], orderedIds: string[] = []): any[] {
        const storedRows = this.getStoredAgentResearchers();
        const lookup = new Map<string, any>();
        const order = new Map<string, number>();

        orderedIds.forEach((id: string, index: number) => {
            if (id) order.set(id, index);
        });

        storedRows.forEach((row: any, index: number) => {
            const key = row.researcher_id || row.id || '';
            if (!key) return;
            lookup.set(key, row);
            if (!order.has(key)) {
                order.set(key, index);
            }
        });

        const merged = (rows || []).map((row: any) => {
            const key = row.researcher_id || row.id || '';
            const saved = key ? (lookup.get(key) || {}) : {};
            const combined = { ...saved, ...row };
            combined.ai_recommended = true;
            combined.recommendation_reason = this.getRecommendationReason(combined);
            return combined;
        });

        if (order.size > 0) {
            merged.sort((left: any, right: any) => {
                const leftKey = left.researcher_id || left.id || '';
                const rightKey = right.researcher_id || right.id || '';
                const leftOrder = order.has(leftKey) ? (order.get(leftKey) as number) : Number.MAX_SAFE_INTEGER;
                const rightOrder = order.has(rightKey) ? (order.get(rightKey) as number) : Number.MAX_SAFE_INTEGER;
                return leftOrder - rightOrder;
            });
        }

        return merged;
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event) {
        let shouldRender = false;
        if (this.searchTabDropdownOpen) {
            this.searchTabDropdownOpen = false;
            shouldRender = true;
        }
        if (this.popoverCardId) {
            this.popoverCardId = '';
            shouldRender = true;
        }
        if (this.showFacetPanel || this.openFacetCategory) {
            this.showFacetPanel = false;
            this.openFacetCategory = '';
            shouldRender = true;
        }
        if (shouldRender) {
            this.service.render();
        }
    }

    private updateUrlParams() {
        const params = new URLSearchParams();
        const normalizedFuzzy = this.enforceFuzzyForCurrentTab();
        if (this.searchText) params.set('q', this.searchText);
        if (this.searchTab !== 'researcher') params.set('tab', this.searchTab);
        if (this.sort !== this.getDefaultSort()) params.set('sort', this.sort);
        if (normalizedFuzzy !== this.getDefaultFuzzy()) {
            params.set('fuzzy', normalizedFuzzy ? 'true' : 'false');
        }
        if (this.page > 1) params.set('page', String(this.page));
        const qs = params.toString();
        const url = '/search' + (qs ? '?' + qs : '');
        history.replaceState(null, '', url);
    }

    public openResearcherDiscoveryPage() {
        const params = new URLSearchParams();
        const keyword = String(this.searchText || '').trim();
        if (keyword) params.set('q', keyword);
        const qs = params.toString();
        location.href = '/researcher-discovery' + (qs ? '?' + qs : '');
    }

    // ── 패싯 네비게이터 ──

    public async loadFacets() {
        if (!this.searchText || (this.searchTab !== 'researcher')) {
            this.stopFacetLoading();
            return;
        }
        const requestSeq = ++this.facetRequestSeq;
        const targetText = this.searchText;
        const targetFuzzy = false;
        this.fuzzySearch = false;
        this.startFacetLoading();
        this.showAllOrgs = false;
        this.keywordsLimit = 30;
        try {
            const { code, data } = await wiz.call("facets", {
                text: targetText,
                fuzzy: targetFuzzy ? 'true' : 'false'
            });
            if (code === 200 && requestSeq === this.facetRequestSeq
                && this.searchTab === 'researcher'
                && this.searchText === targetText
                && this.fuzzySearch === targetFuzzy) {
                this.facets = this.normalizeFacetPayload({
                    orgs: data.orgs || [],
                    keywords: data.keywords || []
                });
            }
        } catch (e) { }
        if (requestSeq === this.facetRequestSeq) {
            this.stopFacetLoading();
            await this.service.render();
        }
    }

    public isOrgSelected(orgName: string): boolean {
        this.ensureFacetSelections();
        return this.selectedOrgs.includes(orgName);
    }

    public isKeywordSelected(keyword: string): boolean {
        this.ensureFacetSelections();
        return this.selectedKeywords.includes(keyword);
    }

    public async toggleFacetOrg(orgName: string) {
        this.ensureFacetSelections();
        const idx = this.selectedOrgs.indexOf(orgName);
        if (idx >= 0) {
            this.selectedOrgs.splice(idx, 1);
        } else {
            this.selectedOrgs.push(orgName);
        }
        this.page = 1;
        if (this.searchTab === 'keyword') {
            await this.loadByKeyword(1, { reuseResultCache: true });
        } else {
            await this.load(1);
        }
    }

    public async toggleFacetKeyword(keyword: string) {
        this.ensureFacetSelections();
        const idx = this.selectedKeywords.indexOf(keyword);
        if (idx >= 0) {
            this.selectedKeywords.splice(idx, 1);
        } else {
            this.selectedKeywords.push(keyword);
        }
        this.page = 1;
        if (this.searchTab === 'keyword') {
            await this.loadByKeyword(1, { reuseResultCache: true });
        } else {
            await this.load(1);
        }
    }

    public async clearFacets() {
        this.selectedOrgs = [];
        this.selectedKeywords = [];
        this.page = 1;
        if (this.searchTab === 'keyword') {
            await this.loadByKeyword(1, { reuseResultCache: true });
        } else {
            await this.load(1);
        }
    }

    public async toggleFacetPanel(event: Event) {
        event.stopPropagation();
        this.showFacetPanel = !this.showFacetPanel;
        await this.service.render();
    }

    public async toggleFacetCategory(event: Event, category: string) {
        event.stopPropagation();
        this.openFacetCategory = this.openFacetCategory === category ? '' : category;
        await this.service.render();
    }

    public get hasFacetFilters(): boolean {
        this.ensureFacetSelections();
        return this.selectedOrgs.length > 0 || this.selectedKeywords.length > 0;
    }

    public get hasFacetData(): boolean {
        return this.facets.orgs.length > 0 || this.facets.keywords.length > 0;
    }

    public get visibleOrgs(): any[] {
        return this.showAllOrgs ? this.facets.orgs : this.facets.orgs.slice(0, 10);
    }

    public get visibleKeywords(): any[] {
        return this.facets.keywords.slice(0, this.keywordsLimit);
    }

    public get hasMoreKeywords(): boolean {
        return this.facets.keywords.length > this.keywordsLimit;
    }

    public get visibleExpandedKeywords(): string[] {
        return this.showAllExpandedKeywords
            ? this.expandedKeywords
            : this.expandedKeywords.slice(0, this.expandedKeywordCollapsedPreviewCount);
    }

    public get hasHiddenExpandedKeywords(): boolean {
        return !this.showAllExpandedKeywords && this.expandedKeywords.length > this.visibleExpandedKeywords.length;
    }

    public async toggleShowAllOrgs() {
        this.showAllOrgs = !this.showAllOrgs;
        await this.service.render();
    }

    public async showMoreKeywords() {
        this.keywordsLimit += 30;
        await this.service.render();
    }

    public async collapseKeywords() {
        this.keywordsLimit = 30;
        await this.service.render();
    }

    public async toggleExpandedKeywords() {
        this.showAllExpandedKeywords = !this.showAllExpandedKeywords;
        await this.service.render();
    }

    // ── 검색/로딩 ──

    public async loadByIds(ids: string[]) {
        this.keywordSearchRequestSeq++;
        this.clearKeywordExpansionStatus();
        this.clearKeywordExpansionModelError();
        this.loading = true;
        this.agentMode = true;
        this.agentSummary = '';
        await this.service.render();

        const { code, data } = await wiz.call("search_by_ids", {
            ids: ids.join(',')
        });

        if (code === 200) {
            this.rows = this.mergeAgentRows(data.rows || [], ids);
            this.total = data.total || this.rows.length;
            this.lastPage = 1;
            this.page = 1;
            const rids = this.rows.map((r: any) => r.researcher_id).filter((id: string) => id);
            await this.checkBookmarks(rids);
            await this.refreshAgentSummary();
        }
        this.loading = false;
        await this.service.render();
    }

    public async clearAgentMode() {
        this.agentMode = false;
        this.agentSummary = '';
        this.agentResultId = '';
        this.rows = [];
        this.total = 0;
        this.clearStoredAgentContext();
        this.updateUrlParams();
        await this.load();
        await this.loadFacets();
    }

    public async load(page: number = this.page, options: any = {}) {
        this.keywordSearchRequestSeq++;
        this.clearKeywordExpansionStatus();
        this.clearKeywordExpansionModelError();
        const targetFuzzy = this.enforceFuzzyForCurrentTab();
        this.loading = true;
        this.page = page;
        this.agentMode = false;
        this.agentResultId = '';
        await this.service.render();

        const params: any = {
            text: this.searchText,
            search_type: 'name',
            page: this.page,
            dump: this.dump,
            sort: this.sort,
            order: this.order,
            fuzzy: targetFuzzy ? 'true' : 'false',
            cache_token: this.ensureKeywordResultCacheToken(),
            cache_reset: options.resetCache === true ? 'true' : 'false'
        };

        // 패싯 필터 적용
        if (this.selectedOrgs.length > 0) {
            params.facet_orgs = this.selectedOrgs.join('|');
        }
        if (this.selectedKeywords.length > 0) {
            params.facet_keywords = this.selectedKeywords.join('|');
        }

        const { code, data } = await wiz.call("search", params);

        if (code === 200) {
            this.rows = data.rows;
            this.total = data.total;
            this.lastPage = Math.ceil(this.total / this.dump) || 1;
            const ids = this.rows.map((r: any) => r.researcher_id).filter((id: string) => id);
            await this.checkBookmarks(ids);
        }
        this.loading = false;
        this.updateUrlParams();
        await this.service.render();
    }

    public async loadByKeyword(page: number = this.page, options: any = {}) {
        const requestSeq = options.requestSeq || ++this.keywordSearchRequestSeq;
        const targetFuzzy = this.normalizeFuzzy('keyword', options.forceExact ? false : this.fuzzySearch);
        this.loading = true;
        this.page = page;
        this.agentMode = false;
        this.agentResultId = '';
        this.clearKeywordExpansionModelError();
        let keywordExpansionError = '';
        const reuseResultCache = options.reuseResultCache === true;
        let reusableExpandedKeywords: string[] = [];
        let hasReusableExpandedKeywords = false;
        let shouldRequestKeywordExpansion = false;
        let pendingExpandedKeywords: string[] = [];

        const params: any = {
            keyword: this.searchText,
            page: this.page,
            dump: this.dump,
            sort: this.sort,
            order: this.order,
            fuzzy: targetFuzzy ? 'true' : 'false',
            cache_token: this.ensureKeywordResultCacheToken(),
            cache_reset: options.resetCache === true ? 'true' : 'false'
        };

        if (this.selectedOrgs.length > 0) {
            params.facet_orgs = this.selectedOrgs.join('|');
        }
        if (this.selectedKeywords.length > 0) {
            params.facet_keywords = this.selectedKeywords.join('|');
        }

        if (targetFuzzy) {
            reusableExpandedKeywords = this.canReuseExpandedKeywords() ? this.expandedKeywords : [];
            hasReusableExpandedKeywords = this.hasUsefulExpandedKeywords(
                reusableExpandedKeywords,
                this.normalizeKeywordTerm(params.keyword)
            );
            shouldRequestKeywordExpansion = !hasReusableExpandedKeywords && !reuseResultCache;
            if (hasReusableExpandedKeywords) {
                params.expanded_keywords = JSON.stringify(reusableExpandedKeywords);
            }
        }

        const shouldShowKeywordExpansionStatus = targetFuzzy
            && (shouldRequestKeywordExpansion || hasReusableExpandedKeywords || reuseResultCache);

        if (shouldShowKeywordExpansionStatus) {
            this.startKeywordExpansionStatus();
        } else {
            this.clearKeywordExpansionStatus();
        }
        await this.service.render();

        try {
            if (targetFuzzy) {
                if (!hasReusableExpandedKeywords && !reuseResultCache) {
                    const { code: expandCode, data: expandData } = await wiz.call("keyword_expand", {
                        keyword: params.keyword
                    });

                    if (requestSeq !== this.keywordSearchRequestSeq) {
                        return;
                    }

                    if (expandCode === 200) {
                        const expandedSearchKeyword = String(expandData.search_keyword || params.keyword || '').trim();
                        if (expandedSearchKeyword) {
                            params.keyword = expandedSearchKeyword;
                        }
                        const expandedKeywords = this.supplementExpandedKeywords(
                            expandData.expanded_keywords || [],
                            params.keyword
                        );
                        keywordExpansionError = this.keywordExpansionErrorFromResponse(expandData);
                        this.keywordExpansionModelError = keywordExpansionError;
                        if (this.hasUsefulExpandedKeywords(expandedKeywords, this.normalizeKeywordTerm(params.keyword))) {
                            pendingExpandedKeywords = expandedKeywords;
                            params.expanded_keywords = JSON.stringify(expandedKeywords);
                        }
                        await this.service.render();
                    } else if (this.isModelProblemMessage(expandData?.message || expandData?.error)) {
                        keywordExpansionError = this.keywordExpansionModelNotice;
                        this.keywordExpansionModelError = keywordExpansionError;
                        await this.service.render();
                    }
                }
            }

            const { code, data } = await wiz.call("keyword_search", params);

            if (requestSeq !== this.keywordSearchRequestSeq) {
                return;
            }

            if (code === 200) {
                const responseSearchKeyword = String(data.search_keyword || params.keyword || '').trim();
                if (responseSearchKeyword) {
                    params.keyword = responseSearchKeyword;
                }
                const nextRows = data.rows || [];
                const nextTotal = data.total || 0;
                const nextExpandedKeywords = targetFuzzy
                    ? this.supplementExpandedKeywords(
                        data.expanded_keywords || pendingExpandedKeywords,
                        params.keyword
                    )
                    : [];
                const responseExpansionError = targetFuzzy ? this.keywordExpansionErrorFromResponse(data) : '';
                const ids = nextRows.map((r: any) => r.researcher_id).filter((id: string) => id);
                this.freezeRenderedMatchedKeywords(nextRows, params.keyword);
                await this.checkBookmarks(ids);
                if (requestSeq !== this.keywordSearchRequestSeq) {
                    return;
                }
                this.rows = nextRows;
                this.total = nextTotal;
                this.expandedKeywords = nextExpandedKeywords;
                this.showAllExpandedKeywords = false;
                this.keywordExpansionModelError = targetFuzzy ? (keywordExpansionError || responseExpansionError) : '';
                this.lastPage = Math.ceil(this.total / this.dump) || 1;
            } else if (targetFuzzy && this.isModelProblemMessage(data?.message || data?.error)) {
                keywordExpansionError = this.keywordExpansionModelNotice;
                this.keywordExpansionModelError = keywordExpansionError;
            }
        } catch (e) {
            if (targetFuzzy && this.isModelProblemMessage(e?.message || e)) {
                keywordExpansionError = this.keywordExpansionModelNotice;
                this.keywordExpansionModelError = keywordExpansionError;
            }
        } finally {
            if (requestSeq === this.keywordSearchRequestSeq) {
                this.loading = false;
                this.clearKeywordExpansionStatus();
                this.updateUrlParams();
                await this.service.render();
            }
        }
    }

    public async loadKeywordFacets() {
        if (!this.searchText || this.searchTab !== 'keyword') {
            this.stopFacetLoading();
            return;
        }
        const requestSeq = ++this.facetRequestSeq;
        const targetText = this.searchText;
        const targetFuzzy = this.normalizeFuzzy('keyword', this.fuzzySearch);
        this.fuzzySearch = targetFuzzy;
        this.startFacetLoading();
        this.showAllOrgs = false;
        this.keywordsLimit = 30;
        try {
            const params: any = {
                keyword: targetText,
                fuzzy: targetFuzzy ? 'true' : 'false',
                sort: this.sort,
                cache_token: this.ensureKeywordResultCacheToken()
            };
            if (targetFuzzy && this.canReuseExpandedKeywords()) {
                params.expanded_keywords = JSON.stringify(this.expandedKeywords);
            }
            const { code, data } = await wiz.call("keyword_facets", params);
            if (code === 200 && requestSeq === this.facetRequestSeq
                && this.searchTab === 'keyword'
                && this.searchText === targetText
                && this.fuzzySearch === targetFuzzy) {
                this.facets = this.normalizeFacetPayload({
                    orgs: data.orgs || [],
                    keywords: data.keywords || []
                });
                if (targetFuzzy && data.expanded_keywords) {
                    const facetSearchKeyword = String(data.search_keyword || targetText || '').trim();
                    const facetExpandedKeywords = this.supplementExpandedKeywords(data.expanded_keywords || [], facetSearchKeyword);
                    if (this.hasUsefulExpandedKeywords(facetExpandedKeywords, this.normalizeKeywordTerm(facetSearchKeyword))) {
                        this.expandedKeywords = facetExpandedKeywords;
                        this.showAllExpandedKeywords = false;
                    }
                }
                const facetModelError = this.keywordExpansionErrorFromResponse(data);
                if (targetFuzzy && facetModelError) {
                    this.keywordExpansionModelError = facetModelError;
                }
            }
        } catch (e) { }
        if (requestSeq === this.facetRequestSeq) {
            this.stopFacetLoading();
            await this.service.render();
        }
    }

    public async onSearch() {
        if (!this.searchText.trim()) {
            this.keywordSearchRequestSeq++;
            this.clearKeywordExpansionStatus();
            this.clearKeywordExpansionModelError();
            this.rows = [];
            this.total = 0;
            this.loading = false;
            this.showFilters = false;
            this.stopFacetLoading();
            this.showEmptyGuide = true;
            await this.service.render();
            return;
        }
        this.showEmptyGuide = false;
        this.page = 1;
        this.resetFacetState(true);
        this.enforceFuzzyForCurrentTab();
        if (this.searchTab === 'keyword') {
            await this.loadByKeyword(1);
            this.loadKeywordFacets();
        } else {
            await this.load(1, { resetCache: true });
            this.loadFacets();
        }
    }

    public async changeTab(tab: string) {
        this.keywordSearchRequestSeq++;
        this.clearKeywordExpansionStatus();
        this.clearKeywordExpansionModelError();
        this.searchTabDropdownOpen = false;
        this.searchTab = this.normalizeSearchTab(tab);
        this.sort = this.getDefaultSort(this.searchTab);
        this.page = 1;
        this.rows = [];
        this.total = 0;
        this.loading = false;
        this.agentMode = false;
        this.resetFacetState(true);
        this.fuzzySearch = this.getDefaultFuzzy(this.searchTab);
        this.updateUrlParams();
        await this.service.render();
    }

    public async toggleSearchTabDropdown(event: Event) {
        event.stopPropagation();
        this.searchTabDropdownOpen = !this.searchTabDropdownOpen;
        await this.service.render();
    }

    public async selectSearchTab(tab: string, event?: Event) {
        if (event) event.stopPropagation();
        const nextTab = this.normalizeSearchTab(tab);
        if (nextTab === this.searchTab) {
            this.searchTabDropdownOpen = false;
            await this.service.render();
            return;
        }
        await this.changeTab(nextTab);
    }

    public async changeSort(sortValue: string) {
        this.sort = this.normalizeSort(sortValue);
        this.page = 1;
        if (this.searchTab === 'keyword') {
            await this.loadByKeyword(1, { reuseResultCache: true });
        } else {
            await this.load(1);
        }
    }

    public async toggleFilters() {
        this.showFilters = !this.showFilters;
        if (this.showFilters && this.facetLoading && !this.hasFacetData) {
            this.facetSkeletonVisible = true;
        }
        await this.service.render();
    }

    public goResearcher(id: string, row: any = null) {
        // 검색 상태를 sessionStorage에 저장 (뒤로가기 시 복원용)
        this.saveSearchStateSnapshot();
        this.service.href(this.buildResearcherDetailUrl(id, row));
    }

    public async toggleFuzzySearch() {
        if (this.searchTab !== 'keyword') {
            this.fuzzySearch = false;
        } else {
            this.fuzzySearch = !this.fuzzySearch;
        }
        await this.service.render();
    }

    public async pageMove(page: number) {
        if (this.searchTab === 'keyword') {
            await this.loadByKeyword(page, { reuseResultCache: true });
        } else {
            await this.load(page);
        }
    }

    public _getAllTags(row: any): string[] {
        if (!row) return [];
        const korKeywords = this.normalizeKeywordList(row.keyword_kor);
        if (korKeywords.length > 0) return this.uniqueKeywords(korKeywords);
        return this.uniqueKeywords(this.normalizeKeywordList(row.keyword_eng));
    }

    public getVisibleTags(row: any): string[] {
        return this._getAllTags(row).slice(0, 3);
    }

    public getExtraTagCount(row: any): number {
        const all = this._getAllTags(row);
        return Math.max(0, all.length - 3);
    }

    public isPopoverOpen(researcherId: string): boolean {
        return this.popoverCardId === researcherId;
    }

    public async togglePopover(event: Event, researcherId: string) {
        event.stopPropagation();
        if (this.popoverCardId === researcherId) {
            this.popoverCardId = '';
        } else {
            this.popoverCardId = researcherId;
        }
        await this.service.render();
    }

    public getFieldTags(fields: string): string[] {
        if (!fields) return [];
        return fields.split(/[;|]/).map(f => f.trim()).filter(f => f).slice(0, 3);
    }

    public getInitial(name: string): string {
        if (!name) return '?';
        return name.charAt(0);
    }

    public async checkSession() {
        try {
            const { code, data } = await wiz.call("check_session");
            if (code === 200 && data.loggedIn) {
                this.isLoggedIn = true;
            }
        } catch (e) { }
    }

    public async checkBookmarks(ids: string[]) {
        if (!this.isLoggedIn || ids.length === 0) return;
        const { code, data } = await wiz.call("check_bookmarks", { ids: ids.join(',') });
        if (code === 200) {
            this.bookmarks = data;
        }
    }

    public async toggleBookmark(event: Event, researcherId: string) {
        event.stopPropagation();
        if (!this.isLoggedIn) return;
        const { code, data } = await wiz.call("toggle_bookmark", { researcher_id: researcherId });
        if (code === 200) {
            this.bookmarks[researcherId] = data.bookmarked;
        }
        await this.service.render();
    }
}

export default PageSearchComponent;